import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2, LinkColumnV2 } from "../../components/DataGridV2/DataColumnsV2";

export const getObjectGridColumns = ({ t,
  keyPrefix,
  i18n,
  apiRef,
  statusOptions
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.OBJECTS_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.OBJECTS_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client",
    getValueForFilter: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },

  })

  return [
     {
      download: true,
      print: true,
      field: "projectNo",
      headerName: t("general.projectNumber"),
      flex: 1,
      minWidth: 108,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.projectNo}
            cellSubMenuOptions={{ options: getOptions({ field: "projectNo", isQuickFilterDisplay: Boolean(rowData.projectNo) }), extraData: { fieldName: "projectNo" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "buildingNoIntern",
      headerName: t("general.buildingNumber"),
      flex: 1,
      minWidth: 108,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.buildingNoIntern}
            cellSubMenuOptions={{ options: getOptions({ field: "buildingNoIntern", isQuickFilterDisplay: Boolean(rowData.buildingNoIntern) }), extraData: { fieldName: "buildingNoIntern" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "propertyType",
      headerName: t("general.homeType"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.propertyType}
            cellSubMenuOptions={{ options: getOptions({ field: "propertyType", isQuickFilterDisplay: Boolean(rowData.propertyType) }), extraData: { fieldName: "propertyType" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "buildingType",
      headerName: t("general.buildingType"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.buildingType}
            cellSubMenuOptions={{ options: getOptions({ field: "buildingType", isQuickFilterDisplay: Boolean(rowData.buildingType) }), extraData: { fieldName: "buildingType" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "constructionFlow",
      headerName: t("general.constructionFlow.label"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.constructionFlow}
            cellSubMenuOptions={{ options: getOptions({ field: "constructionFlow", isQuickFilterDisplay: Boolean(rowData.constructionFlow) }), extraData: { fieldName: "constructionFlow" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "buyerRenterName",
      headerName: t("general.buyerRenterName"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.buyerRenterName}
            cellSubMenuOptions={{ options: getOptions({ field: "buyerRenterName", isQuickFilterDisplay: Boolean(rowData.buyerRenterName) }), extraData: { fieldName: "buyerRenterName" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "address",
      headerName: t("layout.navbar.address"),
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.address}
            cellSubMenuOptions={{ options: getOptions({ field: "address", isQuickFilterDisplay: Boolean(rowData.address) }), extraData: { fieldName: "address" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "status",
      headerName: t("general.status"),
      type: "singleSelect",
      valueOptions: statusOptions,
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.status}
            cellSubMenuOptions={{ options: getOptions({ field: "status", isQuickFilterDisplay: Boolean(rowData.status) }), extraData: { fieldName: "status", type: 'singleSelect' } }}
            request={rowData}
          />
        );
      },
    },
  ];
}

